import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Steps from '@mos-front-components/public/es/components/Steps';
import isEmpty from 'lodash/isEmpty';

import ChatInterval from '../../components/ChatInterval/ChatInterval';
import Spinner from '../../components/Spinner/Spinner';
import StepAgreement from '../../components/StepAgreement/StepAgreement';
import StepEmptySnils from '../../components/StepEmptySnils/StepEmptySnils';

import StepGia from '../StepGia/StepGia';
import StepApplicantType from '../../containers/StepApplicantType/StepApplicantType';
import Correction from '../../containers/Correction/Correction';
import StepPerson from '../StepPerson/StepPerson';
import StepApplicant from '../../containers/StepApplicant/StepApplicant';

import { APPLICANT_TYPES } from '../../constants/applicant';
import { START_STEP, EMPTY_SNILS_STEP } from '../../constants/steps';
import {
  sendCMAAppealStart,
  sendCMAFormStepChange,
} from '../../helpers/CMAStats';

import formStructuredSelector from './formStructuredSelector';

import './Form.pcss';

class Form extends PureComponent {
  componentDidMount() {
    if (!isEmpty(this.props.mainData)) {
      sendCMAAppealStart();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      stepId,
      applicantType,
      completeSTEP1,
      completeSTEPAPPLICANTTYPE,
      completeSTEPAPPLICANT,
      completeSTEP2,
      completeSTEP3,
      completeSTEP4,
      mainData,
    } = this.props;
    const sendCMAStats = () => {
      sendCMAFormStepChange({ form: 'appeal' });
    };

    if (completeSTEP1 && !prevProps.completeSTEP1) {
      sendCMAStats();
    }
    if (completeSTEP2 && !prevProps.completeSTEP2) {
      sendCMAStats();
    }
    if (completeSTEP3 && !prevProps.completeSTEP3) {
      sendCMAStats();
    }
    if (completeSTEP4 && !prevProps.completeSTEP4) {
      sendCMAStats();
    }
    if (completeSTEPAPPLICANTTYPE && !prevProps.completeSTEPAPPLICANTTYPE) {
      sendCMAStats();
    }
    if (
      applicantType === APPLICANT_TYPES.parent &&
      completeSTEPAPPLICANT &&
      !prevProps.completeSTEPAPPLICANT
    ) {
      sendCMAStats();
    }

    if (
      stepId === START_STEP &&
      !isEmpty(mainData) &&
      isEmpty(prevProps.mainData)
    ) {
      sendCMAAppealStart();
    }
  }

  render() {
    const {
      stepId,
      applicantType,
      completeSTEP1,
      completeSTEPAPPLICANTTYPE,
      completeSTEPAPPLICANT,
      completeSTEP2,
      showSTEP3,
      completeSTEP3,
      completeSTEP4,
      showSTEP4,
      showSTEP5,
      mainData,
    } = this.props;

    const content = [
      {
        title: 'Данные участника ГИА',
        content: <StepGia />,
        completed: completeSTEP1,
      },
      {
        title: 'Кем вы являетесь?',
        content: <StepApplicantType />,
        completed: completeSTEPAPPLICANTTYPE,
        disabled: !completeSTEP1,
      },
      {
        title: 'Сведения об участнике ГИА',
        content: (
          <StepPerson
            parentApplicant={applicantType === APPLICANT_TYPES.parent}
          />
        ),
        completed: completeSTEP2,
        disabled:
          !completeSTEPAPPLICANTTYPE ||
          (applicantType === APPLICANT_TYPES.parent && !completeSTEPAPPLICANT),
      },
      {
        title: 'Предмет',
        content: <Correction show={showSTEP3} />,
        completed: completeSTEP3,
        disabled: !showSTEP3 && !completeSTEP2,
      },
      {
        title: <>Выбор предпочтительного времени онлайн-чата</>,
        content: <ChatInterval show={showSTEP4} />,
        completed: completeSTEP4,
        disabled: !showSTEP4 && !completeSTEP3,
      },
      {
        title: 'Подача апелляции',
        content: <StepAgreement show={showSTEP5} />,
        completed: completeSTEP4,
        disabled: !showSTEP5 && !completeSTEP4,
      },
    ];

    const parentBlock = {
      preventRender:
        !applicantType || applicantType === APPLICANT_TYPES.participant,
      title: 'Сведения о законном представителе участника ГИА',
      content: <StepApplicant />,
      completed: completeSTEPAPPLICANT,
      disabled: !completeSTEPAPPLICANTTYPE,
    };

    const fullContent =
      !applicantType || applicantType === APPLICANT_TYPES.participant
        ? content
        : [...content.slice(0, 2), parentBlock, ...content.slice(2, 7)];

    if (stepId === START_STEP && isEmpty(mainData)) {
      return (
        <div className="FormStep">
          <Spinner middle />
        </div>
      );
    }

    if (stepId === EMPTY_SNILS_STEP) {
      return (
        <div className="FormStep">
          <StepEmptySnils />
        </div>
      );
    }

    return (
      <Steps className="FormStep FormStep_statement">
        {fullContent.map((stepItem) => (
          <Steps.Step
            key={stepItem.title}
            title={stepItem.title}
            completed={stepItem.completed}
            disabled={stepItem.disabled}
          >
            {stepItem.content}
          </Steps.Step>
        ))}
      </Steps>
    );
  }
}

Form.defaultProps = {
  showSTEP3: false,
  applicantType: null,
  completeSTEPAPPLICANTTYPE: null,
  completeSTEPAPPLICANT: null,
};

Form.propTypes = {
  stepId: PropTypes.string.isRequired,
  completeSTEP1: PropTypes.bool.isRequired,
  completeSTEPAPPLICANTTYPE: PropTypes.bool,
  completeSTEPAPPLICANT: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  completeSTEP2: PropTypes.bool.isRequired,
  completeSTEP3: PropTypes.bool.isRequired,
  completeSTEP4: PropTypes.bool.isRequired,
  showSTEP3: PropTypes.bool,
  showSTEP4and5: PropTypes.bool,
  applicantType: PropTypes.oneOf([
    APPLICANT_TYPES.parent,
    APPLICANT_TYPES.participant,
  ]),
  mainData: PropTypes.shape({}).isRequired,
};

export default connect(formStructuredSelector)(Form);
